import { pushLayerEvent } from '@/utils/gtag';
import Image from 'next/image';
import { useState } from 'react';

function SearchImage({
  alt,
  src,
  errorImage,
  placeholder,
  quality,
  className = '',
  fill,
  native = false,
  ...props
}) {
  const [newSrc, setNewSrc] = useState(src);

  const trackSearchImageClick = () => {
    console.log('openSearchImage');
    pushLayerEvent('openSearchImage', {});
  };

  return !native ? (
    <Image
      src={newSrc}
      alt={alt} // To fix lint warning
      onError={() => {
        setNewSrc(errorImage);
      }}
      fill
      onClick={trackSearchImageClick}
      sizes="100vw, 50vw"
      placeholder={placeholder}
      blurDataURL={errorImage}
      quality={quality}
      className={className}
      loading="eager"
      {...props}
    />
  ) : (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={`${newSrc}?q=${quality}`}
      alt={alt}
      className={className}
      onClick={trackSearchImageClick}
      onError={() => {
        setNewSrc(errorImage);
      }}
      loading="eager"
      {...props}
    />
  );
}

export default SearchImage;
